<template>
    <div class="row">
        <div class="col p-0">
            <div class="form-group">
                <input
                    @input="handleInput($event, 1)"
                    ref="input_1"
                    type="text"
                    v-model="keys.input_1"
                    class="form-control-single-number"
                    name="input_1"
                    maxlength="6"
                    autocomplete="off"
                    autocapitalize="off"
                    spellcheck="false"
                    @keydown.right="$refs.input_2.focus()"
                    @focus="focusCursorHandler($refs.input_1)">
            </div>
        </div>

        <div class="col p-0">
            <div class="form-group">
                <input
                    @input="handleInput($event, 2)"
                    type="text"
                    v-model="keys.input_2"
                    ref="input_2"
                    class="form-control-single-number"
                    name="input_2"
                    maxlength="6"
                    autocomplete="off"
                    autocapitalize="off"
                    spellcheck="false"
                    @keyup.delete="handleDelete('input_1')"
                    @keyup.left="$refs.input_1.focus()"
                    @keydown.right="$refs.input_3.focus()"
                    @focus="focusCursorHandler($refs.input_2)">
            </div>
        </div>

        <div class="col p-0">
            <div class="form-group">
                <input
                    @input="handleInput($event, 3)"
                    type="text"
                    v-model="keys.input_3"
                    ref="input_3"
                    class="form-control-single-number"
                    name="input_3"
                    maxlength="6"
                    autocomplete="off"
                    autocapitalize="off"
                    spellcheck="false"
                    @keyup.delete="handleDelete('input_2')"
                    @keyup.left="$refs.input_2.focus()"
                    @keydown.right="$refs.input_4.focus()"
                    @focus="focusCursorHandler($refs.input_3)">
            </div>
        </div>

        <div class="col p-0">
            <div class="form-group">
                <input
                    @input="handleInput($event, 4)"
                    type="text"
                    v-model="keys.input_4"
                    ref="input_4"
                    class="form-control-single-number"
                    name="input_4"
                    maxlength="6"
                    autocomplete="off"
                    autocapitalize="off"
                    spellcheck="false"
                    @keyup.delete="handleDelete('input_3')"
                    @keyup.left="$refs.input_3.focus()"
                    @keydown.right="$refs.input_5.focus()"
                    @focus="focusCursorHandler($refs.input_4)">
            </div>
        </div>

        <div class="col p-0">
            <div class="form-group">
                <input
                    @input="handleInput($event, 5)"
                    type="text"
                    v-model="keys.input_5"
                    ref="input_5"
                    class="form-control-single-number"
                    name="input_5"
                    maxlength="6"
                    autocomplete="off"
                    autocapitalize="off"
                    spellcheck="false"
                    @keyup.delete="handleDelete('input_4')"
                    @keyup.left="$refs.input_4.focus()"
                    @keydown.right="$refs.input_6.focus()"
                    @focus="focusCursorHandler($refs.input_5)"
                    >
            </div>
        </div>

        <div class="col p-0">
            <div class="form-group">
                <input
                    @input="handleInput($event, 6)"
                    type="text"
                    v-model="keys.input_6"
                    ref="input_6"
                    class="form-control-single-number"
                    name="input_6"
                    maxlength="6"
                    autocomplete="off"
                    autocapitalize="off"
                    spellcheck="false"
                    @keyup.delete="handleDelete('input_5')"
                    @keyup.left="$refs.input_5.focus()"
                    @focus="focusCursorHandler($refs.input_6)">
            </div>
        </div>

        <input type="hidden" name="2fa_code" :value="code">

        <div v-if="error" class="d-block text-center w-100">
            <span class="text-danger">{{message}}</span>
        </div>

        <div class="col-12 text-center p-0">
            <button
                type="submit"
                id="submit"
                class="btn btn-primary transition-3d-hover"
                :disabled="error && !code ? true: false">
                {{btnPlaceholder}}
            </button>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            keys: {
                input_1: '',
                input_2: '',
                input_3: '',
                input_4: '',
                input_5: '',
                input_6: ''
            },
            itemDeleted: false
        }
    },
    props: {
        error:{
            type: Boolean,
        },
        message: {
            type: String,
        },
        btnPlaceholder: {
            type: String
        }
    },
    computed: {
        code() {
            const { input_1, input_2, input_3, input_4, input_5, input_6 } = this.keys;
            return input_1 + input_2 + input_3 + input_4 + input_5 + input_6;
        }
    },
    methods: {
        handleInput(e, key) {

            const inputValue = [...e.target.value];

            if(this.inputEvent(e)){
                this.handleFirstInputCursor(key, inputValue);
                this.handleInputIncert(inputValue);
                this.handleInputKeyPress(key, inputValue);
            }

        },

        handleInputKeyPress(key, inputValue) {
            let inputAfterDelete = this.firstInputAfterDelete(key);

            if(inputAfterDelete){
                this.focusNextAndInput(key, inputValue);
            }

            if (this.currentCellNotEmpty(key)) {
                this.inputWithDelete(key, inputValue);
            }

            this.itemDeleted ? this.itemDeleted = false : '';

            if(this.lastStepCheck(key) && !inputAfterDelete) {
                let nextInputKey = `input_${key + 1}`;
                this.$refs[nextInputKey].focus();
            }
        },

        lastStepCheck(key) {
            return key <= 5;
        },

        handleFirstInputCursor(key, value){
            let currentInput = `input_${key}`;

            if(key === 1 && this.$refs[currentInput].selectionStart === 1 && value.length === 2){
                this.keys.input_1 = value[0];
            }
        },

        firstInputAfterDelete(key) {
            return this.itemDeleted && this.currentCellNotEmpty(key);
        },

        inputEvent(e) {
           return e.inputType !== 'deleteContentBackward'
        },

        currentCellNotEmpty(key) {
            let currentField = `input_${key}`;

            return this.keys[currentField].length !== 1;
        },

        inputWithDelete(key, target){
            let next = `input_${key + 1}`;
            let currentField = `input_${key}`;
            this.keys[currentField] = target[1];
            this.lastStepCheck() ? this.$refs[next].focus() : '';

        },

        focusNextAndInput(key, target){
            let currentField = `input_${key}`;
            let next = `input_${key + 1}`;
            let afterNext = `input_${key + 2}`;

            this.keys[currentField] = target[0];
            this.keys[next] = target[1];
            this.$refs[afterNext] ? this.$refs[afterNext].focus() : this.$refs[next].focus();
        },

        handleInputIncert(target){
            if (target.length == 6 ) {
                Object.keys(this.keys).forEach((el, i) => {
                    this.keys[el] = target[i];
                });
            }
        },

        handleDelete(previousCell) {
            this.itemDeleted = true;
            this.$refs[previousCell].focus();
        },

        focusCursorHandler(refer){
            refer.selectionStart = 1;
        }
    },
}
</script>
<style scoped lang="scss">
    .col.p-0{
        margin-right: 10px;
    }

    .btn.btn-primary{
        margin: 2rem auto;
    }
</style>
